var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"sm":"12"}},[_c('h1',{staticClass:"text-h4 primary--text"},[_vm._v(" About Our Agency ")]),_c('h2',{staticClass:"text-subtitle-1 primary--text"},[_vm._v("Lorem, ipsum dolor sit amet consectetur adipisicing elit. Minus, eveniet iusto assumenda quidem ducimus neque?")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }